<form class="grid grid-cols-1 md:grid-cols-3 gap-4" [formGroup]="formGroup()">
  <div class="flex flex-col gap-2">
    <label for="phoneNumber" appRequiredLabel="telefon1"
      >Telefon komórkowy</label
    >
    <input
      id="phoneNumber"
      pInputText
      appControlError
      [formControl]="formGroup().controls.telefon1"
      [maxlength]="12"
    />
  </div>
  <div class="flex flex-col gap-2">
    <label for="email" appRequiredLabel="email">Adres e-mail</label>
    <input
      id="email"
      pInputText
      appControlError
      [formControl]="formGroup().controls.email"
      [maxlength]="150"
    />
  </div>
</form>
